import type { PublishedBlogPost } from "../BlogPost.js";

export function getBlogPostPath({ urlSlug }: Pick<PublishedBlogPost, "urlSlug">): string {
	return urlSlug;
}
